import { render, staticRenderFns } from "./HowToGetFile.vue?vue&type=template&id=6d4c30f3&scoped=true"
import script from "./HowToGetFile.vue?vue&type=script&lang=js"
export * from "./HowToGetFile.vue?vue&type=script&lang=js"
import style0 from "./HowToGetFile.vue?vue&type=style&index=0&id=6d4c30f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4c30f3",
  null
  
)

export default component.exports